import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
export let iconDomain = faGlobe;
export function overwriteDomain(icon) {
    iconDomain = icon;
}
export default iconDomain;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9tYWluLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2RvbWFpbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sMkNBQTJDLENBQUM7QUFFcEUsTUFBTSxDQUFDLElBQUksVUFBVSxHQUFHLE9BQU8sQ0FBQztBQUVoQyxNQUFNLFVBQVUsZUFBZSxDQUFDLElBQW9CO0lBQ2xELFVBQVUsR0FBRyxJQUFJLENBQUM7QUFDcEIsQ0FBQztBQUVELGVBQWUsVUFBVSxDQUFDIn0=